module.exports = __webpack_public_path__ + "img/hk_product_global@3x.c0046f13.png";